export enum RoofId {
  Roof1 = "1",
  Roof2 = "2",
  Roof3 = "3",
  Roof4 = "4",
  Roof5 = "5",
  Roof6 = "6",
  Roof7 = "7",
  Roof8 = "8",
  Roof9 = "9",
  Roof10 = "10"
}
